var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrendsIconVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 83,
    viewBox: "0 0 47 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.435547,
    y: 0.45166,
    width: 46.0034,
    height: 82.0874,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0166 15.3403H9.54345C11.2328 15.3403 12.7557 16.3583 13.4017 17.9193L14.8976 21.5344C15.6579 23.3716 18.2163 23.4878 19.14 21.727V21.727C19.5449 20.9552 20.3445 20.4717 21.2161 20.4717H24.4473C26.589 20.4717 28.6233 19.5342 30.0147 17.906V17.906C31.406 16.2779 33.4404 15.3403 35.5821 15.3403H39.8576",
    stroke: "#6F6CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71582 41.5571L10.0615 38.3392C11.3224 36.6093 13.991 36.9277 14.8095 38.9057V38.9057C15.7542 41.1887 18.9997 41.1548 19.8965 38.8526L20.5148 37.2655C21.4144 34.9564 24.4837 34.5011 26.0149 36.4496L26.3388 36.8618C27.4196 38.2372 29.4888 38.2798 30.6252 36.9499V36.9499C31.7588 35.6234 33.8213 35.6616 34.9049 37.0292L39.1576 42.3968",
    stroke: "#6FD7A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.64014,
    y: 53.2192,
    width: 3.26565,
    height: 16.1407,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9058,
    y: 62.0566,
    width: 3.26565,
    height: 7.30333,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1714,
    y: 53.2192,
    width: 3.26565,
    height: 16.1407,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.437,
    y: 57.668,
    width: 3.26565,
    height: 11.6921,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7026,
    y: 53.2192,
    width: 3.26565,
    height: 16.1407,
    rx: 1.63283,
    fill: "#E0EBF4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34.9683,
    y: 63.9185,
    width: 3.26565,
    height: 5.44144,
    rx: 1.63283,
    fill: "#E0EBF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendsIconVertical);
export default __webpack_public_path__ + "static/media/trends_icon_vertical.1a15be62510176e2de2074788140f786.svg";
export { ForwardRef as ReactComponent };